
import { defineComponent } from "@vue/composition-api";
import { mapFields } from "vuex-map-fields";

export default defineComponent({
  name: "PlanTeachingMaterialStep",
  computed: {
    ...mapFields("execution", ["executionPlan.teachingMaterialsRequired"]),
  },
});
